/**
 * 業務語彙の単一情報源（issue #24 の用語表）。
 * 表記揺れを防ぐため、画面ごとの名前空間に業務語を置かない。
 *
 * 「申請」系の語は使わない。BPMN は承認を伴わない業務フロー（棚卸・手続き・
 * 障害対応など）も載せるため、申請前提の語だとメニューが実態と合わなくなる。
 * インスタンスは「案件」、起票した人は「起票者」で統一する
 * （起票者は SpiffArena の process_initiator に対応）。
 * 「承認リクエスト」は承認ステップ専用のメニューなので残す。
 * （#24 の用語表では「マイ申請 / 申請者 / 申請日 / 申請種別」だった。業務フローも
 * 載せる前提が決まったため中立語へ変更。URL とコード識別子は my-applications のまま）
 */
export default {
  case: "案件",
  caseNumber: "案件番号",
  myApplications: "マイ案件",
  approvalRequest: "承認リクエスト",
  applicant: "起票者",
  applicationType: "案件種別",
  currentStep: "現在ステップ",
  status: "ステータス",
  submittedAt: "起票日",
  completedAt: "完了日",
  caseStatus: {
    draft: "下書き",
    inProgress: "承認中",
    returned: "差し戻し",
    completed: "完了",
    canceled: "中止",
    suspended: "一時停止",
    error: "エラー",
  },
} as const;
